import Temp from "@/courier/Temp";

export default class BestExpress extends Temp {
  static CODE = "BEST";
  static ZONE_TYPE = {
    "GBKK_GBKK": 1,
    "GBKK_C-N-NE": 2,
    "GBKK_S": 3,
    "C-N-NE_GBKK": 4,
    "C-N-NE_S": 5,
    "C-N-NE_C-N-NE": 6,
    "S_GBKK": 7,
    "S_C-N-NE": 8,
    "S_S": 9
  }

  constructor() {
    super(BestExpress.CODE);
  }

  async getZone(item) {
    let type, from, to;
    let cross_price = 0;
    let remote_area = 0;
    let fuel_surcharge = 0;

    remote_area = super.checkRemoteArea(Number(item.toPostcode));

    // วิธี map rate_type แบบเก่า
    // from = super.checkZone(item.fromPostcode);
    // to = super.checkZone(item.toPostcode);
    // if (from == 1 && to == 1) { 
    //   // BKK to BKK
    //   type = 1;
    // } else if (from == 1 && to != 1) {
    //   // BKK to UPC
    //   type = 2;
    // } else if (from != 1 && to == 1) {
    //   // UPC to BKK
    //   type = 3;
    // } else {
    //   // ต่างจังหวัด -> ต่างจังหวัด :)
    //   type = 4;
    // }

    const listPostcodeSpecial = JSON.parse(localStorage.getItem("courier_postcode"));
    const zones = Object.keys(listPostcodeSpecial[BestExpress.CODE].zone)
    from = this._checkZone(item.fromPostcode, zones, listPostcodeSpecial[BestExpress.CODE].zone)
    to = this._checkZone(item.toPostcode, zones, listPostcodeSpecial[BestExpress.CODE].zone)

    if (from && to) {
      type = BestExpress.ZONE_TYPE[`${from}_${to}`] || null
    }

    let fuel_surcharge_data = await super.getFuelSurcharge()

    if (fuel_surcharge_data) {
      const useWeight = item.dimensionWeight > item.weight ? item.dimensionWeight : item.weight

      const weightTier = fuel_surcharge_data.weight_tiers
      const priceWeightTier = fuel_surcharge_data.price_weight_tiers

      let weightTierIndex = weightTier.findIndex((tier) => useWeight <= tier)

      if (weightTierIndex === -1) {
        weightTierIndex = weightTier.length - 1
      }

      fuel_surcharge = priceWeightTier[weightTierIndex]
    }

    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
      fuel_surcharge
    };
  }
  
  _checkZone(postcode, zones, data) {
    const index = Object.values(data).findIndex((zip) => {
      let i = zip.findIndex((code) => code == postcode)

      return i > -1
    })

    if (index < 0 || index >= zones.length) {
      return null
    }

    let zone = zones[index]

    if (['C', 'N', 'NE'].includes(zone)) {
      zone = 'C-N-NE'
    }

    return zone
  }

  checkWeight(courierRates, item, validate) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });

    return super.checkRules(item, validate);
  }

  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }

  async checkRemoteAreaByCorrectorDest(addressRemote, option) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["BEST"], option).then((res) => {
        resolve({ 
          isRemote: res.data.BEST.is_remote?50:0,
          isIsland: res.data.BEST.is_island?80:0,
          isTravel: 0//res.data.BEST.is_tourist?0:0
        });
      });
    });
  }
}
